<div class="side-navigation">
  <div *ngFor="let item of menuItems" class="side-navigation-item"
  (click)="updateHeader(item.headerName)">
    <a [routerLink]="item.link"
       [routerLinkActive]="['active-menu-item']">
<!--      <mat-icon [class]="item.icon" class="pr-1"></mat-icon>-->
      {{item.name}}</a>
  </div>
</div>
